import { FILES } from '../../sagas/types';
import { createAction } from '../common';

export const postUploadFile = createAction(FILES.UPLOAD_FILE);
export const getFiles = createAction(FILES.GET_FILES);
export const getDocumentInfo = createAction(FILES.GET_FILE_FULL_INFO);
export const removeDocument = createAction(FILES.REMOVE_FILE);
